/*
 * @Author: renming-lj 2982488597@qq.com
 * @Date: 2024-05-13 16:41:45
 * @LastEditors: renming-lj 2982488597@qq.com
 * @LastEditTime: 2024-06-06 14:32:49
 * @FilePath: \program_admin\src\router\index.js
 * @Description: 路由
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import Home from '@/views/home/index.vue';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3,// 初始化时的最小百分比,
})

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/index',
    component: Home,
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/index',
        name: 'index',
        component: function () {
          return import(/* webpackChunkName: "index" */ '@/views/index/index.vue')
        },
        meta: {
          title: '首页'
        }
      },
      {
        path: '/personal',
        name: 'personal',
        component: function () {
          return import(/* webpackChunkName: "personal" */ '@/views/personal/index.vue')
        },
        meta: {
          title: '个人中心'
        }
      },
      {
        path: '/user',
        name: 'user',
        component: function () {
          return import(/* webpackChunkName: "user" */ '@/views/user/index.vue')
        },
        meta: {
          title: '用户管理'
        }
      },
      {
        path: '/idiom',
        name: 'idiom',
        component: function () {
          return import(/* webpackChunkName: "idiom" */ '@/views/idiom/index.vue')
        },
        meta: {
          title: '成语管理'
        }
      },
      {
        path: '/saying',
        name: 'saying',
        component: function () {
          return import(/* webpackChunkName: "saying" */ '@/views/saying/index.vue')
        },
        meta: {
          title: '歇后语管理'
        }
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: function () {
          return import(/* webpackChunkName: "feedback" */ '@/views/feedback/index.vue')
        },
        meta: {
          title: '反馈管理'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import(/* webpackChunkName: "login" */ '@/views/login/index.vue')
    },
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: function () {
      return import(/* webpackChunkName: "register" */ '@/views/register/index.vue')
    },
    meta: {
      title: '注册'
    }
  },
  {
    path: '/edit',
    name: 'edit',
    component: function () {
      return import(/* webpackChunkName: "edit" */ '@/views/edit/index.vue')
    },
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/404',
    component: function () {
      return import(/* webpackChunkName: "404" */ '@/views/404/index.vue')
    },
    meta: {
      title: '404'
    },
    hidden: true
  },

  //这个*匹配必须放在最后，将改路由配置放到所有路由的配置信息的最后，否则会其他路由path匹配造成影响。     
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start();
  localStorage.setItem('currentPath', to.fullPath);
  document.title = to.meta.title || '管理系统';
  // 进行路由拦截控制
  let token = localStorage.getItem('token');
  if (to.path !== '/login' && to.path !== '/register' && to.path !== '/edit' && !token) {
    // 重定向到登录页
    next('/login');
  } else if (token && (to.path === '/login' || to.path === '/register' || to.path === '/edit')) {
    // 重定向到首页
    next('/home');
  } else {
    next(); // 继续导航
  }
});

router.afterEach((to, from) => {
  // 关闭掉进度条
  NProgress.done();
})

export default router
